import { Suspense } from '#src/atoms/Suspense/index.tsx';
import { LoadingIndicator } from '#src/atoms/loader/LoadingIndicator/index.tsx';
import { lazy } from '#src/lib/retry.ts';

import type { Props as ContentProps } from './Content.tsx';

const Content = lazy(async () => import('./Content.tsx'), 'Content');

interface Props extends Omit<ContentProps, 'children'> {
  data?: string | null;
  inModal?: boolean;
}

export const LazyMarkdown = ({ data, inModal, ...rest }: Props) => {
  return data ? (
    <Suspense fallback={<LoadingIndicator />}>
      <Content {...rest}>{data}</Content>
    </Suspense>
  ) : (
    <LoadingIndicator fullHeight={!inModal} />
  );
};
